import { authFetch } from "./authFetch";

type RegisterWebPushParams = {
  token: string | null;
  userId: number | string | null;
};

function urlBase64ToUint8Array(base64String: string): ArrayBuffer {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = `${base64String}${padding}`.replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let index = 0; index < rawData.length; index += 1) {
    outputArray[index] = rawData.charCodeAt(index);
  }

  return outputArray.buffer as ArrayBuffer;
}

export async function registerAdminWebPush({
  token,
  userId,
}: RegisterWebPushParams): Promise<void> {
  if (!token || !userId) {
    console.warn("[Lynx Push] Sin token o userId. No se registra push.");
    return;
  }

  if (!("serviceWorker" in navigator)) {
    console.warn("[Lynx Push] Este navegador no soporta Service Worker.");
    return;
  }

  if (!("PushManager" in window)) {
    console.warn("[Lynx Push] Este navegador no soporta PushManager.");
    return;
  }

  if (!("Notification" in window)) {
    console.warn("[Lynx Push] Este navegador no soporta notificaciones.");
    return;
  }

  const registration = await navigator.serviceWorker.register("/lynx-push-sw.js");
  console.log("[Lynx Push] Service Worker registrado", registration);

  const permission = await Notification.requestPermission();
  console.log("[Lynx Push] Permiso de notificaciones:", permission);

  if (permission !== "granted") {
    console.warn("[Lynx Push] Permiso no concedido.");
    return;
  }

  const vapidResponse = await authFetch("/v2/notifications/vapid-public-key", {
    method: "GET",
    token,
  });

  const vapidJson = await vapidResponse.json();

  if (!vapidResponse.ok || !vapidJson?.key) {
    console.error("[Lynx Push] No se pudo obtener VAPID public key", vapidJson);
    return;
  }

  const existingSubscription = await registration.pushManager.getSubscription();

  const subscription =
    existingSubscription ||
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidJson.key),
    }));

  console.log("[Lynx Push] Subscription creada/obtenida", subscription);

  const saveResponse = await authFetch("/v2/notifications/web-push-subscription", {
    method: "PUT",
    token,
    json: true,
    body: JSON.stringify({
      id: userId,
      subscription,
    }),
  });

  const saveJson = await saveResponse.json();

  if (!saveResponse.ok) {
    console.error("[Lynx Push] Error guardando subscription", saveJson);
    return;
  }

  console.log("[Lynx Push] Subscription guardada en backend", saveJson);
}

export function listenToWebPushMessages(): () => void {
  const handler = (event: MessageEvent) => {
    if (event.data?.type === "LYNX_PUSH_RECEIVED") {
      console.log("[Lynx Push] Notificación recibida en web app", event.data.payload);
    }
  };

  navigator.serviceWorker?.addEventListener("message", handler);

  return () => {
    navigator.serviceWorker?.removeEventListener("message", handler);
  };
}

export const registerWebPush = registerAdminWebPush;
